import type { ListBuilderList } from '../../../types';
import { createStandardTaskColumns } from '../columns';

/**
 * Today's Tasks list configuration
 * Shows tasks due today for the current user
 */
export const todaysTasksList: ListBuilderList = {
	id: 'todays-tasks',
	cacheTTL: 300000,
	name: 'Today',
	type: 'default',
	active: true,
	sortOrder: 1,
	activeFilters: [
		'taskKeywords',
		'taskStatus',
		'taskPriority',
		'taskAssignedUser',
		'taskClient',
		'taskLeadOrCustomer',
		'taskDueDateRange',
		'taskExternalCalendars',
	],
	columns: createStandardTaskColumns(),
	defaultSortId: 'column-due-date-column-asc',
	filterRules: {
		taskAssignedUser: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'tasks:view:any', negated: true }],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'tasks:view:any', negated: true }],
			},
		},
		taskDueDateRange: {
			defaultValue: [
				{
					id: 'today',
					label: 'Today',
					data: {
						startDate: '{{DATE:0d}}',
						endDate: '{{DATE:0d}}',
					},
				},
			],
		},
		taskStatus: {
			defaultValue: [{ id: 'pending', label: 'Pending' }],
		},
	},
};
